import { useEffect, useState } from 'react';

function getWindowWidth() {
  return typeof window !== `undefined` ? window.innerWidth : 0;
}

const useCheckMobileScreen = (size) => {
  const [width, setWidth] = useState(getWindowWidth());
  const handleWindowSizeChange = () => {
    setWidth(getWindowWidth());
  };

  useEffect(() => {
    window.addEventListener('resize', handleWindowSizeChange);
    window.addEventListener('orientationchange', handleWindowSizeChange);
    window.addEventListener('load', handleWindowSizeChange);
    window.addEventListener('reload', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
      window.removeEventListener('orientationchange', handleWindowSizeChange);
      window.removeEventListener('load', handleWindowSizeChange);
      window.removeEventListener('reload', handleWindowSizeChange);
    };
  }, []);

  return width <= (size || 768);
};

export default useCheckMobileScreen;
